import { Typography } from '@design-system/components/typography/typography';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';
import {
  faAd,
  faCalendar,
  faUserCheck,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { clsx } from 'clsx';
import { padStart } from 'lodash';

export const toCalendlyLink = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const arg = `${year}-${padStart(month + '', 2, '0')}`;
  return `https://calendly.com/jess-playbook/office-hours?month=${arg}`;
};

const supportCards = [
  {
    icon: faFacebook,
    iconClassName: 'bg-[#E5EFFF] text-[#0066FF]',
    title: 'Facebook group',
    details: 'Join community',
    link: 'https://www.facebook.com/groups/playbookcreators',
  },
  {
    icon: faCalendar,
    iconClassName: 'bg-[#FFF0C0] text-[#EBB200]',
    title: 'Office hours',
    details: 'Schedule a call',
    link: toCalendlyLink(),
  },
  {
    icon: faAd,
    iconClassName: 'bg-[#DCFFC0] text-[#5EBB00]',
    title: 'Paid Ad services',
    details: 'Join waitlist',
    link: 'https://playbookapp.typeform.com/to/wc7lUfkZ',
  },
  {
    icon: faUserCheck,
    iconClassName: 'bg-[#FDECFF] text-[#EE2FFF]',
    title: 'Creator accelerator',
    details: 'Apply for coaching',
    link: 'https://www.joinplaybook.com/get-coaching?utm_source=web+app',
  },
];

export const PlaybookSupport = () => (
  <div className="flex flex-col gap-4">
    <Typography variant="headline" size="medium">
      Playbook Support
    </Typography>
    <div className="flex flex-col md:flex-row flex-wrap gap-4 w-full">
      {supportCards.map((card) => (
        <a key={card.title} href={card.link} target="_blank" rel="noreferrer">
          <div className="flex gap-2 rounded-[10px] bg-white p-2 w-full min-w-[240px] md:w-[248px] h-[62px] text-black">
            <div
              className={clsx(
                'flex justify-center items-center w-8 h-8 rounded-md self-center',
                card.iconClassName,
              )}
            >
              <FontAwesomeIcon icon={card.icon} />
            </div>
            <div className="flex flex-col justify-between px-2">
              <Typography variant="body" size="large">
                {card.title}
              </Typography>
              <Typography variant="body">{card.details}</Typography>
            </div>
          </div>
        </a>
      ))}
    </div>
  </div>
);
